import api from "../../core/api";
import { Page } from "../../shared/models/models";
import { ChangeCustomer, Customer, CustomersQuery } from "../models/AdminCustomersModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
}

class AdminCustomersApi {
  getCustomers(query: CustomersQuery): Promise<Page<Customer>> {
    return api.get<Page<Customer>>(`/v1/admin/customers`, { ...getRequestConfig(), params: query }).then(x => x.data);
  }

  getCustomer(id: string): Promise<Page<Customer>> {
    return api.get<Page<Customer>>(`/v1/admin/customers/${id}`, getRequestConfig()).then(x => x.data);
  }

  changeCustomer(id: string, customer: ChangeCustomer): Promise<any> {
    return api.put(`/v1/admin/customers/${id}`, customer, getRequestConfig());
  }

  changeCustomerStatus(id: string, isDisabled: boolean): Promise<any> {
    return api.put(`/v1/admin/customers/${id}/status`, { isDisabled }, getRequestConfig());
  }

  deleteCustomer(id: string): Promise<any> {
    return api.delete(`/v1/admin/customers/${id}`, getRequestConfig());
  }
}

export default new AdminCustomersApi();